const liff = {
    error: '',
    ready: true,
    init: async () => {
        console.log();
    },
    openWindow: async () => {
        console.log();
    },
    closeWindow: async () => {
        console.log();
    },
    shareTargetPicker: () => new Promise((resolve) => setTimeout(() => resolve({ status: 'success' }), 1000)),
    getDecodedIDToken: () => ({ phone_number: '0912345678' }),
    isLoggedIn: () => true,
    isInClient: () => true,
    getFriendship: async () => ({ friendFlag: true }),
    getProfile: async () => ({
        //userId: 'U123...', // U + 32 numbers
        userId: 'U81bd19754c6a92eaf3b0c25b26c0d8ed',
        displayName: '王小明',
        // statusMessage: 'Test test',
        pictureUrl: 'https://home.tappie.tw/logo.png'
    }),
    //getAccessToken: () => ''
    getAccessToken: () =>
        'eyJhbGciOiJIUzI1NiJ9.B29o5e3ti9g-8yJUlQu2iVgGUaSL7N2M9Kh611b6atufK70u0VScOE-IpVpJws-bpNAt0f_ewNI6txLdtVAFsjxGI8x14XZOCwd0CqgSwUWAVkdxQyK8iZ6Qrghv3U-F0sKvTzq2OWEIsFur4Ewn2xcKtN4qCChNqh44xW9ttUg.40V_qy0gt3Pj6aJzhVhSZ9g5H8O5y4dwDbozH9G98Xc'
};

export default liff;
